<template>
  <div style="max-width: 100vw; overflow-x: hidden">
    <pdf-gen
      v-if="staticPdf.contentData"
      :header-data="staticPdf.headerData"
      :content-data="staticPdf.contentData"
      :page-margins="staticPdf.pageMargins"
      :images="staticPdf.images"
      :column-gap="staticPdf.columnGap"
      ref="staticPdf"
    />
    <div v-if="items.length && toPrint.length" :key="key">
      <div v-for="(item, i) in toPrint" :key="'to_print_' + i">
        <template v-if="item[0] && Object.keys(item[0])[0] === 'doc'">
          <v-card
            v-for="(page, j) in item" :key="'page' + j"
            width="100%" :max-width="800"
            flat tile
            color="transparent"
            class="mx-auto"
          >
            <pdf v-for="p in page.pages" :src="page.doc" :page="p" :key="p" class="mb-1" />
          </v-card>
        </template>
        <template v-else>
          <pdf-gen
            v-if="item.length"
            :ref="'gen' + i"
            :header-data="indents ? headerPDF : []"
            :page-margins="indents ? [15, 50, 15, 30] : [0, 0, 0, 0]"
            :footer-data="indents ? null : []"
            :content-data="item"
            :page-size="pageSize"
            :landscape="pageOrientation === 'landscape'"
          />
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex"
import PdfGen from "components/pdf/pdfGen"
import {PDFDocument} from 'pdf-lib'
import pdf from 'vue-pdf'

export default {
  name: "PdfDocumentCreateShow",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    pdf, PdfGen,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    pageSize: {
      type: String,
      default: 'A4'
    },
    pageSizes: {
      type: Object,
      default: () => {
        return { A4: [595.28, 841.89] }
      },
    },
    pageOrientation: {
      type: String,
      default: 'portrait'
    },
    staticPdf: {
      type: Object,
      default: () => {
        return {
          headerData: [],
          contentData: null,
          pageMargins: [15, 50, 15, 30],
          images: [],
          columnGap: 1,
        }
      }
    },
    fileName: {
      type: String,
      default: ''
    },
    uploadFunction: {},
    indents: Boolean,
  },
  computed: {
    headerPDF() {
      return {
        style: 'header',
        table: {
          widths: ['*', 150],
          body: [
            [
              {
                image: 'logo',
                width: 30,
                height: 30,
                margin: [11, 5, 10, 5],
              },
              {
                text: new Date().toLocaleDateString(),
                margin: [0, 17, 11, 5],
                alignment: 'right',
              },
            ],
          ],
        },
        layout: {
          hLineColor: '#d2d5d9',
          vLineWidth: function (i) {
            return 0
          },
        },
      }
    },
    toPrint() {
      let result = []
      let doc = false
      let portrait = this.pageOrientation === 'portrait'
      if (this.items && this.items.length) {
        let temp = []
        for (let i in this.items) {
          if ((doc && !!this.items[i].doc) || (!doc && !this.items[i].doc)) {}
          else {
            result.push(temp)
            temp = []
          }
          if (this.items[i].doc)
            temp.push({doc: this.items[i].data, pages: this.items[i].pages})
          else {
            let itm = {}
            if (this.items[i].breakpage && !doc) itm.pageBreak = 'before'
            if (this.items[i].data) {
              itm.image = this.items[i].data
              itm.margin = this.indents ? [0, 2, 0, 2] : [0, 0, 0, 0]
              let minus = {
                w: this.indents ? 30 : 0,
                h: this.indents ? 84 : 0,
              }
              switch (this.items[i].size) {
                case 'cover':
                  itm.width = this.pageSizes[this.pageSize][portrait ? 0 : 1] - minus.w
                  itm.height = this.pageSizes[this.pageSize][portrait ? 1 : 0] - minus.h
                  break
                case 'contain':
                  itm.fit = [
                    this.pageSizes[this.pageSize][portrait ? 0 : 1] - minus.w,
                    this.pageSizes[this.pageSize][portrait ? 1 : 0] - minus.h
                  ]
                  break
                case 'auto':
                  break
                default:
                  itm.fit = [
                    (this.pageSizes[this.pageSize][portrait ? 0 : 1] - minus.w) * this.items[i].size / 100,
                    (this.pageSizes[this.pageSize][portrait ? 1 : 0] - minus.h) * this.items[i].size / 100
                  ]
              }
            }
            else if (this.items[i].text) {
              itm.table = {
                widths: ['*'],
                body: [[{
                  text: this.items[i].text,
                  alignment: 'center',
                  style: 'header_black_12',
                  margin: [0, 5, 0, 0]
                }]]
              }
              itm.layout = {
                hLineWidth: function (i, node) { return 0 },
                vLineWidth: function (i, node) { return 0 },
                fillColor: function (i, node) { return '#f2f2f2' }
              }
              itm.margin = [0, 2, 0, 2]
            }
            temp.push(itm)
          }
          doc = !!this.items[i].doc
        }
        result.push(temp)
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.key++
      return result
    },
  },
  data: () => ({
    key: 0,
  }),
  methods: {
    ...mapActions(['uploadFile']),
    async downloadDocument() {
      let documents = []
      if (this.$refs.staticPdf)
        documents.push(this.$refs.staticPdf.getBase64())
      for (let i in this.toPrint) {
        if (this.toPrint[i] && this.toPrint[i][0] && this.toPrint[i][0].doc) {
          for (let d in this.toPrint[i])
            documents.push(this.toPrint[i][d].doc)
        } else {
          if (this.$refs['gen' + i])
            documents.push(this.$refs['gen' + i][0].getBase64())
        }
      }
      const mergedPdf = await PDFDocument.create()
      for (let document of documents) {
        document = await PDFDocument.load(document)
        const copiedPages = await mergedPdf.copyPages(document, document.getPageIndices())
        this.numberOfAdded += 1
        copiedPages.forEach((page) => mergedPdf.addPage(page))
      }
      let save = await mergedPdf.save()
      if (this.uploadFunction)
        await this.uploadPDF(save, this.fileName)
      else await this.downloadBlob(save, this.fileName + '.pdf')
    },

    async uploadPDF(data, fileName) {
      const file = new File([data], fileName)
      let size = file.size
      let formData = new FormData()
      formData.append('file', file)
      await this.uploadFile({data: formData}).then(res => {
        if (this.uploadFunction) this.uploadFunction(res.data.url, this.fileName, size)
      })
    },

    downloadBlob(data, fileName) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const url = window.URL.createObjectURL(blob)
      this.downloadURL(url, fileName)
    },

    downloadURL(data, fileName) {
      const a = document.createElement('a')
      a.href = data
      a.download = fileName
      document.body.appendChild(a)
      a.style.display = 'none'
      a.click()
      a.remove()
    },
  }
}
</script>